<!-- src/pages/exam/Complete.vue -->
<template>
  <main class="exam-complete">
    <section class="hero" aria-labelledby="page-title">
      <div class="section__inner hero__inner">
        <h2 id="page-title">자격증</h2>
        <p><strong>ICI Korea </strong> Recognizing Competency World-Wide</p>


      </div>
    </section>
    <!-- 진행 단계 -->
    <div class="steps" aria-label="접수 단계">
      <div class="step">
        <span class="step__num" aria-hidden="true">01</span>
        <span class="step__label">기본정보</span>
      </div>
      <span class="step__arrow" aria-hidden="true">></span>
      <div class="step is-active">
        <span class="step__num" aria-hidden="true">02</span>
        <span class="step__label">접수완료</span>
      </div>
    </div>

    <!-- 완료 본문 -->
    <section class="complete-wrap" aria-labelledby="complete-title">
      <div class="complete-grid">
        <!-- 좌: 완료 카드 -->
        <article class="complete-card">
          <div class="icon-wrap" aria-hidden="true">
            <i class="fa-regular fa-circle-check"></i>
          </div>
          <h1 id="complete-title" class="title">접수가 완료되었습니다</h1>
          <p class="desc">
            지원해 주셔서 감사합니다. 접수 내역은 <strong>마이페이지</strong>에서 확인하실 수 있으며,
            시험 일정 및 안내는 입력하신 이메일로 발송됩니다.
          </p>
          <div class="cta">
            <router-link to="/" class="btn btn--ghost" aria-label="홈으로 이동">홈으로</router-link>
            <!-- <router-link to="/myPage" class="btn btn--primary" aria-label="마이페이지로 이동">마이페이지</router-link> -->
            <router-link 
              v-if="isLogin"
              to="/myPage" 
              class="btn btn--primary" 
              aria-label="마이페이지로 이동">
              마이페이지
            </router-link>
          </div>
        </article>

        <!-- 우: 다음 안내 -->
        <!-- <aside class="next-steps" aria-labelledby="next-title">
          <h2 id="next-title" class="sub-title">다음 단계 안내</h2>
          <ul class="steps-list">
            <li>
              <strong>이메일 확인</strong>
              <p>시험 일정/고사장 정보가 이메일로 발송됩니다. 스팸함도 함께 확인해 주세요.</p>
            </li>
            <li>
              <strong>신분증 지참</strong>
              <p>시험 당일 여권 또는 주민등록증 등 공인 신분증을 반드시 지참하세요.</p>
            </li>
            <li>
              <strong>응시 규정 숙지</strong>
              <p>부정행위, 지각 등 응시 규정을 <router-link to="/noticeList">공지사항</router-link>에서 확인하세요.</p>
            </li>
          </ul>
        </aside> -->
      </div>
    </section>
  </main>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const isLogin = computed(() => {
  return !!store.state.temp?.userInfo?.userId
})
</script>

<style scoped>

.hero {
  background:
    linear-gradient(rgba(13, 6, 20, .65), rgba(13, 6, 20, .65)),
    url('/src/assets/certificationMain.jpeg') center 70% / 65% no-repeat;
  color: #fff;
}

.hero__inner {
  padding: 130px 16px;
  text-align: center;
}

.hero h2 {
  font-family: 'Noto Sans KR', sans-serif;
  font-weight: 700;
  color: #fff;
  font-size: 40px;
  text-align: center;
  letter-spacing: -1px;
  line-height: 1.3;
}

.hero p {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  text-align: center;
  margin-top: 12px;
  letter-spacing: -0.3px;
  line-height: 1.6;
}

.hero p strong{
  font-size: 1.225rem;
  font-weight: 700;
}

/* 폰트/기본 타이포 (요청사항) */
.exam-complete {
  font-family: 'Noto Sans KR', sans-serif;
  color: #0f172a;
}

.title {
  font-size: 1.625rem;
  font-weight: 700;
  letter-spacing: -0.2px;
}

p {
  font-size: 0.95rem;
  line-height: 1.7;
}

/* 진행 단계 바 (Apply.vue와 톤 맞춤 가벼운 스타일) */
.steps {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 36px 0 20px;
  color: #555;
  font-size: 14px;
  justify-content: center;
}
.step {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  opacity: 0.6;
}
.step.is-active { opacity: 1; font-weight: 600; }
.step__num {
  display: inline-flex;
  width: 28px; height: 28px;
  border-radius: 50%;
  border: 1px solid #ddd;
  align-items: center; justify-content: center;
  font-size: 12px;
}
.step__arrow { opacity: .4 }

/* 본문 래퍼 */
.complete-wrap {
  max-width: 800px;
  margin: 0 auto;
  padding: 24px 16px 64px;
}

/* 그리드 레이아웃 (요청사항: grid 사용) */
.complete-grid {
  display: grid;
  /* grid-template-columns: 1fr; */
  gap: 28px;
}

/* 완료 카드 */
.complete-card {
  display: grid;
  gap: 14px;
  padding: 28px;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  background: #ffffff;
}

.icon-wrap {
  font-size: 52px;
  line-height: 1;
  color: #16a34a;
}

.desc {
  color: #334155;
}

.cta {
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  gap: 10px;
  margin-top: 8px;
}

/* 우측 안내 패널 */
.next-steps {
  display: grid;
  gap: 12px;
  padding: 24px;
  border: 1px dashed #e2e8f0;
  border-radius: 16px;
  background: #f8fafc;
}

.sub-title {
  font-size: 1.125rem;
  font-weight: 700;
  letter-spacing: -0.2px;
}

.steps-list {
  display: grid;
  gap: 12px;
}

.steps-list li {
  display: grid;
  gap: 4px;
}

.steps-list strong {
  font-size: 0.98rem;
}

.steps-list p {
  color: #475569;
}

/* 버튼 */
.btn {
  display: inline-grid;
  place-items: center;
  min-width: 120px;
  height: 44px;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  text-decoration: none;
  font-weight: 600;
}

.btn--primary {
  background: #1d2088;
  color: #fff;
  border-color: #1d2088;
}

.btn--ghost {
  background: #fff;
  color: #1f2937;
}

/* 반응형 */
@media (max-width: 900px) {
  .complete-grid {
    grid-template-columns: 1fr;
  }
  .cta {
    grid-auto-flow: row;
    justify-items: stretch;
  }
  .btn { width: 100%; }
}
</style>
